export default {"src":"/_next/static/media/spIcon.ec55e567.svg","height":11,"width":11,"blurWidth":0,"blurHeight":0};